module.exports = __webpack_public_path__ + "img/avatar.300eb1b8.svg";